import fa from 'element-ui/lib/locale/lang/fa';

// 波斯语(伊朗)
export default {
  ...fa,
  layout: {
    title: 'ورود به سیستم با شناسه Uniportal',
    tip: 'شماره تلفن همراه ثبت نشده پس از ورود موفقیت آمیز ، به طور خودکار ثبت می شود',
    line: 'سایر گزینه‌های ورود به سیستم',
  },
  button: {
    submit: 'ورود/ ثبت نام',
    getCode: 'کد کپچا',
    emailRegister: 'ثبت‌نام با ایمیل',
    w3Login: 'ورود حساب W3',
    employeeLogin: 'ورود کارمند',
    passwordLogin: 'ورود اسم رمز',
    reSend: 'ارسال مجدد',
    problem: 'راهنمای آنلاین',
    privacyPolicy: 'سیاست خصوصی',
  },
  placeholder: {
    phoneNumber: 'شماره تلفن همراه',
    verificationCode: 'کد تأييد پیامکی',
  },
  dialog: {
    imgCode: 'نویسه‌های روی تصویر را وارد کنید.',
    userAgreements: {
      header: 'توافقنامۀ کاربری و بیانیۀ حریم خصوصی',
      text1: 'لطفاً {privacy} و {agreement} را بخوانید و با آنها موافقت کنید.',
      text2:
        'اطلاعات شخصی در هنگام دسترسی به برنامه های کاربردی هواوی در خارج از کشور به شرکت های تابعه هواوی در خارج از کشور منتقل می شود، برای جزئیات بیشتر به {privacy} مراجعه کنید',
    },
    crossBorder: {
      header: 'اعلان مجوز',
      text: 'خدمات محلی که از آن استفاده می کنید در همان منطقه ای نیست که حساب شما ثبت شده است. برای دسترسی به اطلاعات حساب مرزی، به اجازه شما نیاز است.',
    },
    multiAccounts: 'حسابی را انتخاب کنید.',
    agreeButton: 'موافقت کردن و ادامه دادن',
    disagreeButton: 'مخالفم',
    confirmButton: 'تأیید',
    cancelButton: 'لغو',
    knowMe: 'تأیید',
  },
  toast: {
    hasSend: 'کد وارسی ارسال شد',
    wait: 'لطفاً ، منتظر بمانید',
  },
  tooltip: {
    Huawei: 'شناسۀ Huawei',
    Tencent: 'QQ',
    Wechat: 'Wechat',
    Weibo: 'Weibo',
    Google: 'Google',
    Facebook: 'Facebook',
    Linkedin: 'LinkedIn',
  },
  errorCode: {
    // 图形验证码错误
    'IDC-00-00013': 'کد CAPTCHA نباید خالی باشد.',
    'IDC-03-0002': 'کد CAPTCHA منقضی شده است.',
    'IDC-00-0004': 'کد CAPTCHA نادرست است.',

    // 表单输入为空
    'IDC-01-00024': 'کد کشور برای تأیید شماره تلفن همراه شما لازم است.',
    phoneNumberEmpty: 'شماره تلفن همراه را وارد کنید.',
    'IDC-03-00033': 'کد تأیید پیامکی را وارد کنيد.',

    // 表单数据错误
    'IDC-02-00227': 'شمارۀ تلفن همراه واردشده با کشور/ منطقه برگزیده تطبیق نمی کند',
    'IDC-02-00226': 'استفاده از کد کشور ممنوع شد',
    'IDC-02-00029': 'کد وارسی نادرست است یا منقضی شده است',
    'IDC-02-0013': 'خرابی در ورود پیام کوتاه ، خطای کد وارسی',
    'IDC-02-0020': 'تأیید نشد. کد تأیید نادرست است.',
    'IDC-02-00028': 'شماره تلفن همراه باید بین 6 تا 30 باشد',
    'IDC-02-00012': 'خطای شمارۀ تلفن همراه',

    // 错误操作锁定
    accountLock:
      'شماره تلفن همراه یا کد تأیید نادرست است. ‏{number} تلاش باقی مانده است. | شماره تلفن همراه یا کد تأیید نادرست است. ‏{number} تلاش باقی مانده است.',
    accountLocked:
      'Quá nhiều lần thử không thành công. Vui lòng thử lại sau {number} giây. | تعداد تلاش‌های ناموفق بیش از حد مجاز است. لطفاً {number} ثانیه دیگر دوباره امتحان کنید.',
    operationRisk: 'عمليات فعلي خطرات امنيتي داره لطفاً در ثانیه های {number} دوباره سعی کنید.',

    // 频繁操作
    'IDC-02-00038': 'لطفاً ۶۰ ثانیه دیگر دوباره امتحان کنید.',
    'IDC-02-00064':
      'کدهای تاییدیه ی پیام کوتاه خیلی زیاد فرستادی. لطفا 24 ساعت بعد دوباره سعي کنيد',
    'IDC-02-00211': 'عمليات فعلي خطرات امنيتي داره لطفا بعدا سعي کنيد',
    'IDC-02-00212':
      'تعداد کدهای تایید شده ی پیام کوتاه که با شماره ی همراه شما ارسال شده خیلی زیاد است.' +
      ' لطفا شماره تلفن همراه خود را تغییر دهید یا ۲۴ ساعت بعد دوباره سعی کنید.',
    'IDC-02-00213':
      'کدهای تاییدیه ی پیام کوتاه خیلی زیاد فرستادی. لطفا 24 ساعت بعد دوباره سعي کنيد',
    'IDC-02-00215':
      'تعداد کدهای تایید شده ی پیام کوتاه که با شماره ی همراه شما ارسال شده، خیلی زیاد است. لطفاً' +
      ' ، سعی کنید شمارۀ تلفن همراهتان را تغییر دهید ، یا روش وارسی دیگری را انتخاب کنید ، یا در ساعتهای {} دوباره سعی کنید.',
    'IDC-02-00228':
      'اگر اغلب کدهای وارسی پیام متنی را ارسال کرده اید ، لطفاً ، یک ساعت بعد دوباره سعی کنید!',
    'IDC-02-00092': 'عمليات فعلي خيلي زياد است لطفا 24 ساعت بعد دوباره سعي کنيد',

    // 请求异常
    'IDC-10-00400': 'درخواست مشتری غیر عادی است ',
    'IDC-10-00500': 'خطای درونی سیستم ',
    'IDC-02-00264': 'درخواست های غیرمجاز برای دستیابی ممنوع است',
    'IDC-02-00063': 'پارامتر نامعتبر',
    'IDC-03-0007': 'عملیات جاری دارای خطرات امنیتی است و در حال حاضر نمی توان ثبت نام کرد.', // 机翻
    'IDC-03-00057': 'عمليات فعلي خطرات امنيتي داره',

    // 页面过期
    'IDC-00-00017': 'صفحه منقضی شده است.',
  },

  // 注册协议、隐私声明对话框
  backButton: 'بازگشت',
  closeButton: 'بستن',

  // 滑块验证相关：
  resourceReqFailed: 'خرابی درخواست منبع. صفحه رو دوباره پاک کن و دوباره امتحان کن',
  verifyFailedAndPlsRetry: 'خرابی در وارسی. لطفاً ، دوباره سعی کنید',
  serviceErrAndPlsRetry: 'استثنای سرویس لطفا دوباره سعی کنید',
  learnMore: 'بیشتر بدانیم',
  cookieBannerText:
    'این وب سایت از کوکی ها استفاده می کند تا بهترین تجربه کاربری ممکن را برای شما فراهم کند.',
};
